import React, { FC } from 'react';
import Footer from '../Footer';
import Navbar from '../Navbar';
import { Container } from 'react-bootstrap';

import '../../styles/app.scss';
import * as styles from './Layout.module.scss';

interface LayoutProps {
  disableContainer?: boolean;
}

const Layout: FC<LayoutProps> = ({ children, disableContainer }) => {
  return (
    <div className={styles.container}>
      <Navbar/>
      <div className={styles.content}>
        {!disableContainer
         ? <Container>
              {children}
            </Container>
         : children}
      </div>
      <Footer/>
    </div>
  );
};

export default Layout;